// extracted by mini-css-extract-plugin
module.exports = {"button":"_9330de7794--button--Ih12C","prev":"_9330de7794--prev--l_lvR","next":"_9330de7794--next--IA8k3"};